export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="32"
      fill="none"
      viewBox="0 0 42 32"
    >
      <defs>
        <path
          id="calendarIconDay"
          d="M0.26 2.45a96 96 0 0 1-.256-1.847c-.047-.372.138-.593.518-.6.603-.01 1.207.001 1.81-.003.357-.003.56.185.61.516q.136.908.232 1.82c.036.337-.152.538-.5.545-.603.011-1.207.016-1.81-.003-.26-.009-.514-.09-.604-.428"
        />
        <g id="calendarIconRing">
          <path
            fill="#3e1472"
            d="M13.468 3.119a95 95 0 0 1-.05 2.302c-.214.476-.53.76-.992.875-.352.088-.615-.031-.668-.315-.057-.31.105-.5.482-.53.293-.022.414-.178.413-.454 0-.147-.007-.294-.01-.441l.015-1.4c0-.412.013-.756 0-1.099A1.277 1.277 0 0 0 11.354.832a1.297 1.297 0 0 0-1.284 1.256c-.009.356-.004.712-.005 1.068-.24 0-.479 0-.75-.006.028-.627-.024-1.284.169-1.859.32-.955 1.336-1.436 2.297-1.237.968.2 1.674 1.07 1.68 2.069.002.32.002.641.008.996"
          />
          <path
            fill="#8056df"
            d="M12.615 4.546c.032.156.038.303.038.45.002.277-.12.432-.412.455-.378.029-.54.219-.482.53.053.283.315.402.668.314.462-.115.778-.398.993-.841.281.58.034 1.266-.573 1.613-.54.31-1.337.159-1.702-.322-.393-.518-.438-1.051-.133-1.54.364-.582.884-.803 1.603-.659"
          />
        </g>
      </defs>
      {/* other parts */}
      <path
        fill="#d0bef7"
        d="M38.185 9.19c-2.97.034-5.941.038-8.913.04-7.854.002-15.709.003-23.607-.027a86 86 0 0 1-.482-3.361c-.106-.83-.025-1.618.695-2.175.267-.206.596-.333.896-.497.812-.006 1.624-.012 2.503-.016.307.003.547.002.821 0 .871 0 1.709.001 2.553.036.001.478-.004.922-.037 1.357-.719-.144-1.24.077-1.603.658-.306.49-.26 1.023.133 1.54.364.482 1.161.633 1.702.323.606-.347.854-1.033.587-1.666.012-.772.026-1.51.04-2.249l5.119.001c.308.002.548.001.823.001.873 0 1.711 0 2.555.033.001.478-.003.922-.036 1.363-.874-.19-1.644.303-1.792 1.125-.09.505.19 1.103.634 1.354.538.302 1.2.25 1.621-.128.423-.38.559-.96.342-1.503.017-.77.035-1.507.053-2.244l5.113.001.828-.002c.872 0 1.709-.001 2.553.032.005.456.004.879-.03 1.305-.685-.046-1.262.076-1.627.695a1.37 1.37 0 0 0 .225 1.667c.45.445 1.134.502 1.699.14.494-.316.696-.92.495-1.508l.06-2.327c1.058 0 2.119.03 3.177-.01 1.076-.04 2.225.648 2.39 2.117.145 1.3.337 2.597.51 3.925"
      />
      <path
        fill="#3b0f71"
        d="M8.132 31.953c-2.095.005-4.191.033-6.286.007-1.147-.014-1.982-1.062-1.828-2.23q.43-3.26.889-6.516c.478-3.39.97-6.777 1.454-10.167.348-2.437.692-4.876 1.067-7.326.08.335.14.682.184 1.03.16 1.279.308 2.56.471 3.837.132 1.035.285 2.067.42 3.1.159 1.23.302 2.461.464 3.69.16 1.205.336 2.407.499 3.61.182 1.338.353 2.677.537 4.015.187 1.36.383 2.721.576 4.082.064.449.104.903.2 1.345.163.752.745 1.155 1.353 1.523"
      />
      <path
        fill="#612ebd"
        d="M8.166 31.962c-.643-.377-1.224-.78-1.387-1.532-.096-.442-.136-.896-.2-1.345-.193-1.36-.39-2.72-.576-4.082-.184-1.338-.356-2.677-.537-4.015-.164-1.203-.34-2.405-.499-3.61-.162-1.228-.305-2.46-.465-3.689-.134-1.034-.287-2.066-.42-3.1-.162-1.278-.31-2.559-.47-3.838a14 14 0 0 0-.177-1.06c.02-.902.228-1.723 1.061-2.184.35-.192.778-.268 1.18-.33.337-.053.687-.008 1.064-.007-.268.164-.596.29-.863.497-.72.557-.8 1.344-.695 2.175.14 1.11.292 2.22.45 3.36.209 1.607.399 3.184.608 4.759q.711 5.33 1.438 10.658c.213 1.562.445 3.122.67 4.743.035 1.262.466 2.19 1.714 2.557.01.003.009.045.013.068-.626-.006-1.25-.011-1.91-.025"
      />
      <path
        fill="#dccdf9"
        d="M10.108 32c-.038-.037-.037-.078-.046-.081-1.25-.368-1.68-1.295-1.706-2.527a.35.35 0 0 1 .183.135c.452.78 1.116 1.174 2.027 1.174q14.145-.003 28.292-.002c1.146 0 1.886-.64 2.071-1.817.2.916.335 1.847-.514 2.588a1.9 1.9 0 0 1-1.313.49 33182 33182 0 0 0-28.043-.002c-.305 0-.61.036-.95.042"
      />
      {/* days background */}
      <path
        fill="#fefefe"
        d="m38.51 9.333.498 3.527c.156 1.103.309 2.206.47 3.309.158 1.09.33 2.178.487 3.268.14.982.263 1.966.4 2.948.155 1.103.325 2.204.475 3.308.146 1.067.276 2.136.414 3.268-.184 1.21-.924 1.85-2.07 1.85q-14.145 0-28.292.003c-.911 0-1.575-.394-2.027-1.174-.04-.067-.117-.112-.185-.197-.232-1.59-.464-3.15-.677-4.711q-.727-5.328-1.437-10.658Q6.25 11.71 6 9.346c7.887 0 15.742-.001 23.596-.004 2.972 0 5.943-.006 8.915-.009"
      />
      <use href="#calendarIconRing" />
      <use href="#calendarIconRing" x="9.32" />
      <use href="#calendarIconRing" x="18.64" />
      {/* other days */}
      <g fill="#ddcdf9">
        <use href="#calendarIconDay" x="14.4" y="11.9" />
        <use href="#calendarIconDay" x="18.9" y="12" />
        <use href="#calendarIconDay" x="23.4" y="12" />
        <use href="#calendarIconDay" x="27.8" y="12" />
        <use href="#calendarIconDay" x="32.3" y="12" />
        <use href="#calendarIconDay" x="10.5" y="16.4" />
        <use href="#calendarIconDay" x="15" y="16.4" />
        <use href="#calendarIconDay" x="19.5" y="16.4" />
        <use href="#calendarIconDay" x="23.9" y="16.4" />
        <use href="#calendarIconDay" x="28.4" y="16.4" />
        <use href="#calendarIconDay" x="32.9" y="16.4" />
        <use href="#calendarIconDay" x="15.5" y="20.8" />
        <use href="#calendarIconDay" x="29" y="20.8" />
        <use href="#calendarIconDay" x="11.1" y="20.9" />
        <use href="#calendarIconDay" x="20" y="20.9" />
        <use href="#calendarIconDay" x="33.4" y="20.9" />
        <use href="#calendarIconDay" x="11.6" y="25.3" />
        <use href="#calendarIconDay" x="16.1" y="25.3" />
        <use href="#calendarIconDay" x="20.6" y="25.3" />
      </g>
      {/* highlighted day */}
      <use href="#calendarIconDay" fill="#f4c246" x="24.5" y="20.9" />
    </svg>
  )
}
